"use client";

import AvatarBase from "@/components/atoms/avatarBase/AvatarBase";
import Badge from "@/components/atoms/badge/Badge";
import LeadIcon from "@/components/atoms/svg/icons/LeadIcon";
import NoteIcon from "@/components/atoms/svg/icons/NoteIcon";
import ProfileDropdown from "@/components/molecules/profileDropdown/ProfileDropdown";
import { USER } from "@/constants/mock";
import useProfileStore from "@/stores/profile";
import { AnimatePresence, motion } from "framer-motion";
import Link from "next/link";
import { useEffect, useState } from "react";

export default function AuthButtonGroup() {
  // State
  const [openMenuProfile, setOpenMenuProfile] = useState<boolean>(false);
  const [isLoading, setLoading] = useState<boolean>(true);

  const { profile, token } = useProfileStore();

  // Get current page
  // TODO: Open this when Phase 2 is ready
  // const pagename = usePathname();

  // Remove slash
  // const page = pagename.replace("/", "");

  // TODO: Open this when Phase 2 is ready
  const isShowAgentFeeds = false;

  // TODO: Open this when Phase 2 is ready
  // const isShowAgentFeeds = page !== "my-agent";

  useEffect(() => {
    let isMounted = true;

    if (isMounted) setLoading(false);

    return () => {
      isMounted = false;
    };
  }, [token]);

  if (token && profile && !isLoading) {
    return (
      <div className="flex gap-2 items-center">
        <ul className="flex gap-2">
          {isShowAgentFeeds && (
            <li>
              <Link
                href={"/agent-feeds"}
                className="btn-default flex-1 gap-2 h-10 flex items-center justify-center"
              >
                <NoteIcon />
                Agent Feeds
                <Badge className="border-base-alpha/[0.08] border leading-caption-m tracking-caption-m">
                  16
                </Badge>
              </Link>
            </li>
          )}

          <li>
            <Link
              href="/create"
              className="btn-purple btn-large flex-1 h-10 min-w-[133px] text-sm flex items-center justify-center whitespace-nowrap gap-1"
            >
              <LeadIcon className="opacity-60" fill="#FFFFFF" />
              <span className="text-white font-medium">Create Agent</span>
            </Link>
          </li>
        </ul>
        <div className="relative">
          <button onClick={() => setOpenMenuProfile(!openMenuProfile)}>
            <AvatarBase
              avatar_img={profile.avatar_img || USER.avatar_img}
              className="w-10 h-10 rounded-full overflow-hidden"
            />
          </button>
          <AnimatePresence>
            {openMenuProfile && (
              <motion.div
                className="absolute right-0 mt-2"
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.3 }}
              >
                <ProfileDropdown email={profile.email || USER.email} />
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    );
  }

  if (!token && !isLoading)
    return (
      <ul className="flex gap-2">
        <li>
          <Link
            href={"/login"}
            className="btn-default flex-1 gap-1 w-[69px] h-10 flex items-center justify-center"
          >
            Login
          </Link>
        </li>
        <li>
          <Link
            href="/register"
            className="btn-purple btn-large flex-1 h-10 w-[133px] text-sm !text-white flex items-center justify-center whitespace-nowrap"
          >
            Sign up for free
          </Link>
        </li>
      </ul>
    );

  return <></>;
}
